<!--
 * @Author: “周晓清“ “zhouxq@yxt.com”
 * @Date: 2022-11-24 14:51:07
 * @LastEditors: “周晓清“ “zhouxq@yxt.com”
 * @LastEditTime: 2022-11-24 14:57:26
 * @FilePath: \yxt-biz-pc\packages\project-plan-select\src\components\planDate.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div >
    <yxt-date-picker
      v-model="date"
      :disabled="disabled"
      :editable="false"
      class="width-full"
      :type="timeType[category]"
      :format="timeFormat[category]"
      :value-format="timeFormat[category]"
      clearable
      @change="changeDate">
    </yxt-date-picker>
  </div>
</template>

<script>

export default {
  props: {
    disabled: Boolean,
    value: {
      type: String,
      default: ''
    },
    category: [Number, String]
  },
  watch: {
    category(v) {
      this.date = '';
      v === 3 && (this.date = null);
      this.changeDate();
    },
    value: {
      handler(val) {
        if (val) {
          this.date = val;
        }
      },
      immediate: true
    }
  },
  data() {
    this.timeFormat = ['yyyy', 'yyyy-MM', 'yyyy-MM'];
    this.timeType = ['year', 'quarter', 'month'];

    return {
      date: ''
    };
  },
  methods: {
    changeDate() {
      this.$emit('input', this.date);
      this.$emit('change', this.date);
    }
  }
};
</script>
